import { Link, useNavigate } from "react-router-dom";
import "./header.css";
import logo from "../images/Logo.avif"
import { useSelector } from "react-redux";
import Search from "./Search";
import Searchbar from "./Searchbar";


const Header = () => {
    const navigate = useNavigate();
    const cartvalue = useSelector((store) => {
        return store.cartt.items

    })
   
    

    return (
        <header>
            <nav class="navbar navbar-expand-lg navbar-light  fixed-top" style={{ backgroundColor: "#836CA9" }}>
                <div class="container-fluid">
                    <div class="navbar-brand"  onClick={()=>{navigate("/")}}>
                        <img src={logo} className="logo" alt="" width="36" height="36" class="d-inline-block align-text-top" />
                    </div>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div class="navbar-nav mx-auto">
                            <Link to="/" class="navlink">Home</Link>
                            <Link to="/frames" class="navlink">Frames</Link>

                            <Link to="/potrait-arts" class="navlink">Potrait-Arts</Link>
                            <Link to="/handmade-gifts" class="navlink">Handmade-gifts</Link>
                            <Link to="/best-seller" class="navlink">Best-seller</Link>
                            
                        </div>
                        <Searchbar> </Searchbar>
                       
                        
                        <div class="icon my-2 my-lg-0">
                            <Link to="/login"> <i class="fa-regular fa-user nav-icon mx-4"></i> </Link>
                            <Link to="/cart"> <i class="fa-solid fa-cart-shopping navicon position-relative">
                                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger pillsize">
                                   {cartvalue.length}
                                    <span class="visually-hidden">unread messages</span>
                                </span>
                            </i> </Link>




                        </div>

                    </div>
                </div>
            </nav>
        </header>


    )

}
export default Header;